// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.async.PollResponse
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { AsyncResponse } from "abweb/dto/async/AsyncResponse";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class PollResponseBase {
  /** Do NOT invoke directly, instead use strongly typed createPollResponseBase factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawada.PollResponse";
  }
  initFromJson(json, deserializeContext) {
    this.initPollResponse(json.numPending, json.responseStamp != null ? json.responseStamp : null, json.responses != null ? TSOGUtils.decodeObjectArray(json.responses, AsyncResponse, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "responses")) : null, json.shutdown);
  }
  initPollResponse(numPending, responseStamp, responses, shutdown) {
    this._numPending = numPending;
    this._responseStamp = responseStamp;
    this._responses = responses;
    this._shutdown = shutdown;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["numPending"] = this._numPending;
    retVal["responseStamp"] = this._responseStamp;
    retVal["responses"] = TSOGUtils.toTSOGArray(this._responses, serializeContext);
    retVal["shutdown"] = this._shutdown;
    return retVal;
  }
  get numPending() {
    return this._numPending;
  }
  set numPending(value) {
    this._numPending = value;
  }
  get responseStamp() {
    return this._responseStamp;
  }
  set responseStamp(value) {
    this._responseStamp = value;
  }
  get responses() {
    return this._responses;
  }
  set responses(value) {
    this._responses = value;
  }
  get shutdown() {
    return this._shutdown;
  }
  set shutdown(value) {
    this._shutdown = value;
  }
}
//# sourceMappingURL=PollResponseBase.js.map
